import moment from "moment";

export const generateYearOptions = (startYear = 2024) => {
  const currentYear = moment().year();
  const years = [];

  for (let year = currentYear + 1; year >= startYear; year--) {
    const previousYear = year - 1;
    years.push({
      label: `${previousYear}-${year}`,
      value: moment({ year }).startOf("year").toISOString(),
    });
  }

  return years;
};
